const services = [
  {
    icon: 'ri-building-4-line',
    title: 'New Construction Framing',
    description: 'Precision structural framing for residential and commercial projects. We build the backbone of your vision with expert craftsmanship and top-grade materials.',
    features: ['Wood & Steel Framing', 'Residential & Commercial', 'Code Compliant', 'On-Time Delivery'],
    image: 'https://public.readdy.ai/ai/img_res/2a2367dffd5b6ddb8f0e40b043a73cd6.jpg',
  },
  {
    icon: 'ri-hammer-line',
    title: 'Concrete Services',
    description: 'From foundations to flatwork, our concrete team delivers durable, beautiful results. Driveways, slabs, foundations — we pour it right the first time.',
    features: ['Foundations & Slabs', 'Driveways & Patios', 'Retaining Walls', 'Decorative Concrete'],
    image: 'https://storage.readdy-site.link/project_files/e845be91-21af-465c-b474-fcdc6906f86f/64691b20-c788-4db3-9eec-9922ae975e71_image0000054.jpg?v=28c785abe806bb5dd2d33814488dd854',
  },
  {
    icon: 'ri-tools-line',
    title: 'Remodeling',
    description: 'Transform your existing space into something extraordinary. Kitchen, bathroom, whole-home renovations — we handle every detail from demo to final finish.',
    features: ['Kitchen & Bath', 'Whole-Home Renovations', 'Room Additions', 'Interior & Exterior'],
    image: 'https://readdy.ai/api/search-image?query=beautiful%20modern%20kitchen%20remodel%20in%20progress%20in%20Texas%20home%2C%20new%20cabinets%20being%20installed%2C%20bright%20open%20concept%20design%2C%20warm%20wood%20tones%20and%20white%20finishes%2C%20professional%20renovation%20photography&width=600&height=400&seq=svc003&orientation=landscape',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-24 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-4">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
              <span className="text-orange-500 text-sm font-bold tracking-widest uppercase">Our Expertise</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 leading-tight">
              Comprehensive<br />
              <span className="text-orange-500">Construction Solutions</span>
            </h2>
          </div>
          <p className="text-gray-500 text-base max-w-xs md:text-right leading-relaxed">
            Serving the Dallas-Fort Worth area with premium craftsmanship and unmatched reliability.
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.title}
              className="bg-white rounded-2xl overflow-hidden group hover:-translate-y-2 transition-transform duration-300"
            >
              {/* Image */}
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-xl mb-4">
                  <i className={`${service.icon} text-orange-500 text-2xl`}></i>
                </div>
                <h3 className="text-xl font-black text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-5">{service.description}</p>

                <ul className="space-y-2">
                  {service.features.map((feat) => (
                    <li key={feat} className="flex items-center gap-2 text-sm text-gray-700">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-check-line text-orange-500 font-bold"></i>
                      </div>
                      {feat}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Footer */}
              <div className="px-6 pb-6">
                <a
                  href="#contact"
                  onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}
                  className="flex items-center gap-2 text-orange-500 font-bold text-sm hover:gap-3 transition-all cursor-pointer whitespace-nowrap"
                >
                  Get a Quote
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA Banner */}
        <div className="mt-16 bg-orange-500 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-2xl md:text-3xl font-black text-white mb-2">Not sure what you need?</h3>
            <p className="text-orange-100 text-base">Call us and we&apos;ll walk you through every option — no pressure, just honest advice.</p>
          </div>
          <a
            href="tel:6824502501"
            className="bg-white text-orange-500 font-black px-8 py-4 rounded-xl text-base hover:bg-orange-50 transition-colors whitespace-nowrap flex items-center gap-2 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill"></i>
            </div>
            (682) 450-2501
          </a>
        </div>
      </div>
    </section>
  );
}
